export default {
    FINANCE_REQUEST_ACCEPT: "FINANCE_REQUEST_ACCEPT",
    FINANCE_REQUEST_PAY: "FINANCE_REQUEST_PAY",
    FINANCE_REQUEST_EXPORT: "FINANCE_REQUEST_EXPORT",
    SPENDINGS: "SPENDINGS",
    SPENDINGS_IMPORT: "SPENDINGS_IMPORT",
    SPENDINGS_EXPORT: "SPENDINGS_EXPORT",
};
